export const GET_ALL_PAY_SYSTEM = "GET_ALL_PAY_SYSTEM"
export const CREATE_PAY_SYSTEM = "CREATE_PAY_SYSTEM"
export const UPDATE_PAY_SYSTEM = "UPDATE_PAY_SYSTEM"
export const DELETE_PAY_SYSTEM = "DELETE_PAY_SYSTEM"
